<template>
  <div class="my-collection">
    <result-size
      :title="this.$route.params.folderId"
      :icon="require('@/assets/images/icons/star2.png')"
      :curPage="this.curPage"
      :resultNum="this.resultNum"
      :pageNum="this.pageNum"
      :pageSize="this.pageSize"
      @changeCurPage="handleChangeCurPage"
      @changePageSize="handleChangePageSize"
    ></result-size>
    <div
      class="content"
      v-loading="loading"
      element-loading-text="加载中"
      element-loading-spinner="el-icon-loading"
    >
      <collection-book
        v-for="book in collectionBooks"
        :key="book.id"
        :book="book"
        @deleteCollect="handleDeleteCollect(book)"
      ></collection-book>
      <div style="width:140px; height:0;" v-for="n in 5" :key="n"></div>
    </div>
    <my-dialog
      :title="'提示'"
      :icon="require('@/assets/images/userPage/user.png')"
      ref="messageDialog"
      class="message-dialog"
      @confirm="clearHistory"
    >
      确认取消该收藏？
    </my-dialog>
    <div class="page-bar">
      <page-bar></page-bar>
    </div>
  </div>
</template>

<script>
import CollectionBook from '../../components/CollectionBooks.vue'
import PageBar from '../../components/PageBar.vue'
import ResultSize from '../../components/ResultSize.vue'
import MyDialog from '../../components/MyDialog.vue'
import { Message } from 'element-ui'
export default {
  name: 'MyCollection',
  components: { CollectionBook, PageBar, ResultSize, MyDialog },
  data () {
    return {
      resultNum: 0,
      pageNum: 0,
      curPage: 1,
      storeId: 0,
      pageSize: 10,
      collectionBooks: [],
      loading: true
    }
  },
  created () {
    this.storeId = Number(this.$route.query.storeId)
    this.getCollect()
  },
  mounted () {
    this.storeId = Number(this.$route.query.storeId)
    this.getCollect()
  },
  watch: {
    $route (val, from) {
      this.storeId = val.query.storeId
      this.getCollect()
    }
  },
  methods: {
    getCollect () {
      // 获取收藏
      this.loading = true
      let url = 'retrieve/storeBook/selectBookInStore?pageNum=' + this.curPage + '&pageSize=' + this.pageSize + '&storeId=' + this.storeId
      this.$http.get(url).then(res => {
        this.collectionBooks = []
        this.loading = false
        // console.log(res.data.data)
        this.resultNum = res.data.data.bookTotalCount
        this.pageNum = Math.ceil(this.resultNum / this.pageSize)
        let tmp = res.data.data.bookList
        for(let i in tmp) {
          let element = tmp[i]
          // console.log(element)
          if(element){
            let bookname = element.bookName
            if (bookname.length > 7) {
              bookname = bookname.slice(0,7) + '...'
            }
            tmp[i] = {
              id: i,
              bookId: element.id,
              name: bookname,
              image: require('@/assets/images/bookCover/u553.jpg'),
              author: element.author.split('；')[0],
              class: element.classification,
              year: element.completionTime,
              edition: element.edition,
              position: element.library
            }
            let url = '/retrieve/page/getImage'
            let params = {
              bookId: element.id,
              page: 1
            }
            this.$http({
              method: 'get',
              url: url,
              params: params,
              responseType: 'blob'
            }).then(res => {
              const binaryData = []
              binaryData.push(res.data)
              const url = window.URL.createObjectURL(
                new Blob(binaryData, { type: 'image/jpg' })
              )
              tmp[i].image = url
            })
          }
        }
        // console.log(this.collectionBooks)
        this.collectionBooks = tmp
      })
        .catch(err => {
          console.log(err)
        })
    },
    handleChangeCurPage (page) {
      this.curPage = page
      this.getCollect()
    },
    handleChangePageSize (size) {
      this.pageSize = size
      if (this.curPage !== 1) {
        this.curPage = 1
      }
      this.getCollect()
    },
    // 取消收藏
    handleDeleteCollect (item) {
      this.$refs.messageDialog.open(() => {
        // console.log(item)
        let userId = localStorage.getItem('userId')
        let url =
          'retrieve/storeBook/deleteBookInStore?userId=' +
          userId +
          '&bookId=' +
          item.bookId
        this.$http
          .delete(url)
          .then(res => {
            // console.log('取消收藏成功')
            Message({
              type: 'success',
              message: '取消收藏成功!'
            })
            this.collectionBooks = this.collectionBooks.filter(
              t => t.bookId !== item.bookId
            )
            this.resultNum = this.resultNum - 1
            this.pageNum = Math.ceil(this.resultNum / this.pageSize)
          })
          .catch(err => {
            // console.log('失败')
            Message({
              type: 'error',
              message: '取消收藏失败!'
            })
          })
      })
    },
    clearHistory () {
      this.$refs.messageDialog.close()
    }
  }
}
</script>

<style scoped>
.my-collection {
  padding-left: 20px;
  padding-top: 10px;
  padding-right: 20px;
  height: 100%;
}

.content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 20px;
  height: 660px;
  overflow-y: scroll;
}

.content >>> .el-loading-spinner i {
  color: #9e5c1d;
  font-size: 30px;
}

.content >>> .el-loading-spinner p {
  color: #634c37;
  font-size: 18px;
}

.page-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  margin-top: auto;
  margin-bottom: 10px;
}

/* 滚动条 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-track {
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.06);
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: rgba(158, 92, 29, 0.2);
}
.message-dialog >>> .el-dialog {
  width: 380px;
  height: 265px;
}

.message-dialog >>> .el-dialog__body {
  height: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #634c37;
}
</style>



// WEBPACK FOOTER //
// src/views/user/MyCollection.vue